<template>
  <div class="m-card-primary m-the-modal-content">
    <form
      autocomplete="off"
      name="the-modal-form"
      @submit.prevent="createFamiliaManual"
    >
      <header class="m-the-modal-header">
        <h5>{{ $t('mEditionMapEnrollmentsFamiliesModalCreate.title') }}</h5>
        <AtomButtonTheModalCloseIcon/>
      </header>
      <section class="m-the-modal-section">
        <AtomInputPrimary
          v-model="familia.nombre"
          :inputError="$v.familia.nombre.$error"
          :label="$t('mEditionMapEnrollmentsFamiliesModalCreate.inputs.nombre.label')"
          :messageError="messageErrorNombre"
          name="nombre"
          :placeholder="$t('mEditionMapEnrollmentsFamiliesModalCreate.inputs.nombre.placeholder')"
          type="text"
          @blur="$v.familia.nombre.$touch()"
        />
        <p>
          <AtomAvatarEdition
            avatar-class="xlarge"
            :is-family-avatar="true"
            :user-info="{email: familia.nombre, fecha_alta: familia.fecha_alta}"
            wrapper-class="margin-right-large"
            @changeAvatarImage="changeAvatarImage"
          />
        </p>
      </section>
      <footer class="m-the-modal-footer">
        <AtomButtonTheModalCancelAction :cancel-text="$t('mEditionMapEnrollmentsFamiliesModalCreate.buttonCancel')"/>
        <AtomButtonPrimary :button-primary="buttonPrimary"/>
      </footer>
    </form>
  </div>
</template>

<script>
import { maxLength, minLength, required } from 'vuelidate/lib/validators'

export default {
  name: 'MoleculeEditionMapEnrollmentsFamiliesModalCreate',

  data () {
    return {
      academiaId: '',

      buttonPrimary: {
        action: this.$t('mEditionMapEnrollmentsFamiliesModalCreate.buttonPrimary'),
        class: 'a-button-assets-primary',
        sending: false,
        type: 'submit'
      },

      familia: {
        nombre: '',
        logo: ''
      },

      showLoadingState: true
    }
  },

  validations: {
    familia: {
      nombre: {
        maxLength: maxLength(60),
        minLength: minLength(1),
        required
      }
    }
  },

  computed: {
    messageErrorNombre () {
      return this.$validation.getValidationMessage('mEditionMapEnrollmentsFamiliesModalCreate', this.$v.familia.nombre, 'nombre')
    }
  },

  watch: {
    'familia.email' () {
      this.familia.email = this.familia.email.toLowerCase()
    }
  },

  created () {
    this.academiaId = this.$store.getters.getAcademyData.id
    this.proyectoId = this.$route.params.id
  },

  methods: {
    changeAvatarImage (avatarImg) {
      this.familia.logo = avatarImg
    },
    createFamiliaManual () {
      this.$v.$touch()
      if (!this.$v.$invalid && !this.buttonPrimary.sending) {
        this.buttonPrimary.sending = true
        this.$services.create('familia', 'createFamilia', { mapa: this.proyectoId, nombre: this.familia.nombre, logo: this.familia.logo }, [this.academiaId])
          .then(response => {
            this.$modal.updateData()
            this.$alerts.pushAlert('mEditionMapEnrollmentsFamiliesModalCreate', 'createFamilia', 'success', 'a-alert-success')
            this.$modal.closeModal()
            this.$license.readAcademiaRecursosUsados()
            this.buttonPrimary.sending = false
          })
          .catch(error => {
            console.log(error)
            this.$license.readAcademiaRecursosUsados()
            this.$alerts.pushAlert('mEditionMapEnrollmentsFamiliesModalCreate', 'createFamilia', 'error', 'a-alert-danger')
            this.buttonPrimary.sending = false
          })
      }
    }
  }
}
</script>
